import { Home, Scroll, Settings, Video, HelpCircle, History } from "lucide-react";
import { ConditionsAllergiesIcon } from "~/components/icons/conditions-allergies-icon";
import { MedicationIcon } from "~/components/icons/medication-icon";

export const weightLossNavigationItems: NavigationItem[] = [
  {
    title: "Home",
    url: "/dashboard/weight-loss",
    icon: <Home />,
    notifications: 1
  },
  // {
  //   title: "Medicals",
  //   url: "/dashboard/weight-loss/medicals",
  //   matchUrls: ["/dashboard/weight-loss/medicals", "/dashboard/weight-loss/medicals/medications", "/dashboard/weight-loss/medicals/conditions"],
  //   icon: <ClipboardPlus />
  // },
  {
    title: "Appointments",
    url: "/dashboard/weight-loss/appointments",
    matchUrls: [
      "/dashboard/weight-loss/appointments", 
      "/dashboard/weight-loss/appointments/upcoming", 
      "/dashboard/weight-loss/appointments/past"],
    icon: <Video />
  },
  {
    title: "Settings",
    url: "/dashboard/weight-loss/settings",
    matchUrls: [
      "/dashboard/weight-loss/settings",
    ],
    icon: <Settings />
  },
    {
    title: "Support",
    url: "/dashboard/weight-loss/support",
    matchUrls: ["/dashboard/weight-loss/support"],
    icon: <HelpCircle />
  }
];

export const urgentCareNavigationItems: NavigationItem[] = [
  {
    title: "Home",
    url: "/dashboard/urgent-care",
    icon: <Home />,
    notifications: 1
  },
  {
    title: "Encounters",
    url: "/dashboard/urgent-care/encounters",
    matchUrls: ["/dashboard/urgent-care/encounters"],
    icon: <Scroll />
  },
  {
    title: "Appointments",
    url: "/dashboard/urgent-care/appointments",
    matchUrls: ["/dashboard/urgent-care/appointments"],
    icon: <Video />
  },
  {
    title: "Settings",
    url: "/dashboard/urgent-care/settings",
    matchUrls: [
      "/dashboard/urgent-care/settings"
    ],
    icon: <Settings />
  },
  {
    title: "Support",
    url: "/dashboard/urgent-care/support",
    matchUrls: ["/dashboard/urgent-care/support"],
    icon: <HelpCircle />
  }
];

export const medicalsNavigationItems: NavigationItem[] = [
  {
    title: "Medications",
    description: "Weight loss overview",
    url: "/dashboard/medicals/$program",
    matchUrls: [
      "/dashboard/medicals/weight-loss",
      "/dashboard/medicals/urgent-care"
    ],
    icon: <MedicationIcon />,
    notifications: 1,
    dynamicUrl: (program: string) => `/dashboard/medicals/${program}`,
    isDynamicRoute: true
  },
  {
    title: "Conditions & Allergies",
    description: "",
    url: "/dashboard/medicals/$program/conditions-allergies",
    matchUrls: [
      "/dashboard/medicals/weight-loss/conditions-allergies",
      "/dashboard/medicals/urgent-care/conditions-allergies"
    ],
    icon: <ConditionsAllergiesIcon />,
    dynamicUrl: (program: string) => `/dashboard/medicals/${program}/conditions-allergies`,
    isDynamicRoute: true
  },
  {
    title: "Payment history",
    description: "",
    url: "/dashboard/medicals/$program/payment-history",
    matchUrls: [
      "/dashboard/medicals/weight-loss/payment-history",
      "/dashboard/medicals/urgent-care/payment-history"
    ],
    icon: <History />,
    dynamicUrl: (program: string) => `/dashboard/medicals/${program}/payment-history`,
    isDynamicRoute: true
  },
  {
    title: "Support",
    description: "",
    url: "/dashboard/medicals/$program/support",
    matchUrls: [
      "/dashboard/medicals/weight-loss/support",
      "/dashboard/medicals/urgent-care/support"
    ],
    icon: <HelpCircle />,
    dynamicUrl: (program: string) => `/dashboard/medicals/${program}/support`,
    isDynamicRoute: true
  }
];

export const platformSwitchItems = [
  {
    title: "Weight Loss",
    platform: "weight-loss",
    url: "/dashboard/weight-loss",
    disabled: false
  },
  // {
  //   title: "Urgent Care",
  //   platform: "urgent-care",
  //   url: "/dashboard/urgent-care",
  //   disabled: true
  // },
  {
    title: "Medicals",
    platform: "medicals",
    url: "/dashboard/medicals",
    disabled: false
  }]

export type NavigationItem = {
  title: string;
  description?: string;
  url: string;
  matchUrls?: string[];
  icon?: React.ReactNode;
  notifications?: number;
  program?: string;
  disabled?: boolean;
  dynamicUrl?: (program: string) => string;
  isDynamicRoute?: boolean;
};
